import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit {

  constructor() {}
  ngOnInit(): void {
  }
}
